import {
  getApi,
  login,
  generatePdf,
  uploadExhibitors,
} from '../repos/api';

import {
  getAuthCookie,
  setAuthCookie,
  removeAuthCookie,
} from '../repos/cookies';

export default class AppService {
  async authenticate(accountId: string, password: string, type?: string): Promise<string> {
    const api = getApi();
    const response = await login(api, { accountId, password }, type);
    setAuthCookie(response.data.token, type);
    return response.data.token;
  }

  async generatePdf(url: string, token?:string|null, key?:string) {
    const api = getApi(token);
    let pdfUrl = url + "?token=" + token;
    if (key) pdfUrl = url + "?key=" + key;
    const response = await generatePdf(api, { url: pdfUrl });
    return response;
  }

  async uploadExhibitors(token: string, params: FormData) {
    const api = getApi(token);
    const response = await uploadExhibitors(api, params)
    return response;
  }

  unauthenticate(type?: string){
    removeAuthCookie(type);
  }

  getAuthToken(type?: string) {
    return getAuthCookie(type);
  }
}